// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarDays16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-days': IconCalendarDays;
    }
}

/**
 * The icon component for the 'calendarDays' icon
 */
export class IconCalendarDays extends IconSvg {
    public constructor() {
        super(calendarDays16X16);
    }
}

registerIconSvg('icon-calendar-days', IconCalendarDays);
export const iconCalendarDaysTag = 'nimble-icon-calendar-days';
